import React, { useContext } from 'react';
import { ask__ } from './../../shared/utils/i18n.js';

import './Footer.scss';

export default function Footer() {

  return (
    <div className="app__footer">
      <a
        className="app__footer__terms"
        href={ask__('Login: Terms and conditions url')}
        target="_blank"
      >
        {ask__('Login: Terms and conditions footer')}
      </a>
    </div>
  )

}
